import { render, staticRenderFns } from "./PowerCurves.vue?vue&type=template&id=2dacf3b3"
import script from "./PowerCurves.vue?vue&type=script&lang=js"
export * from "./PowerCurves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports